module.exports = __webpack_public_path__ + "media/images/carte-cadeau-noel-1eaf025fd9f5bc3682240b7b66538986.png";